export const formattedText = (number: number): string => {
  let formattedNumber = number.toString().split('.')

  for (let i = formattedNumber[0].length; i > 0; i -= 3) {
    formattedNumber[0] = formattedNumber[0].slice(0, i) + ' ' + formattedNumber[0].slice(i).trimEnd()
  }

  return formattedNumber.join(',')
}
